export default {
  methods: {
    subscribeEndpoint(endpoint, callback) {
      this.$socketService.subscribeEndpoint(this, endpoint, callback)            
    },
    unsubscribeEndpoint(endpoint) {
      this.$socketService.unsubscribeEndpoint(this, endpoint)
    },
    subscribeRoom(room) {
      this.$socketService.subscribeRoom(this, room)
    },
    unsubscribeRoom(room) {
      this.$socketService.unsubscribeRoom(this, room)
    },
    addSocketEventListener(event, callback) {
      this.$socketService.addSocketEventListener(this, event, callback)
    },
    removeSocketEventListener(event) {
      this.$socketService.removeSocketEventListener(this, event)
    }

  }
}